// @ngInject
function ResourceInit(DS) {
    DS.defineResource({
        name: 'article',
        idAttribute: 'id',
        endpoint: 'articles'
    });

    DS.defineResource({
        name: 'articlecollections',
        idAttribute: 'id',
        endpoint: 'articlecollections'
    });

    DS.defineResource({
        name: 'articlevariants',
        idAttribute: 'id',
        endpoint: 'articlevariants'
    });

    DS.defineResource({
        name: 'basedonarticle',
        idAttribute: 'id',
        endpoint: 'articlevariants/basedonarticle'
    });

    DS.defineResource({
        name: 'brand',
        idAttribute: 'id',
        endpoint: 'brands'
    });

    DS.defineResource({
        name: 'company',
        idAttribute: 'id',
        endpoint: 'companies'
    });

    DS.defineResource({
        name: 'country',
        idAttribute: 'id',
        endpoint: 'countries'
    });

    DS.defineResource({
        name: 'dashboard',
        idAttribute: 'id',
        endpoint: 'dashboard'
    });

    DS.defineResource({
        name: 'itemgroups',
        idAttribute: 'id',
        endpoint: 'itemgroups'
    });

    DS.defineResource({
        name: 'location',
        idAttribute: 'id',
        endpoint: 'locations'
    });

    DS.defineResource({
        name: 'mainGroup',
        idAttribute: 'id',
        endpoint: 'maingroups',
        relations: {
            hasMany: {
                subcategory: {
                    localField: 'subcategories',
                    foreignKey: 'mainGroupId'
                }
            }
        }
    });

    DS.defineResource({
        name:'order',
        idAttribute: 'id',
        endpoint: 'orders'
    });

    DS.defineResource({
       name:'orderarticle',
        idAttribute: 'id',
        endpoint: 'orderarticles'
    });

    DS.defineResource({
        name: 'subcategory',
        idAttribute: 'id',
        endpoint: 'subcategories',
        relations: {
            belongsTo: {
                mainGroup: {
                    parent: true,
                    localKey: 'mainGroupId',
                    localField: 'mainGroup'
                }
            }
        }
    });

    DS.defineResource({
        name: 'user',
        idAttribute: 'id',
        endpoint: 'users'
    });

    DS.defineResource({
        name: 'variant',
        idAttribute: 'id',
        endpoint: 'variants'
    });

    DS.defineResource({
        name: 'variantgroup',
        idAttribute: 'id',
        endpoint: 'variantgroups'
    });

    DS.defineResource({
        name: 'vats',
        idAttribute: 'id',
        endpoint: 'vats'
    });
}

angular
    .module('init.angularData',[])
    .run(ResourceInit);
